export const StatsCardSkeleton = () => {
  return (
    <div className="border border-neutral-200 rounded-md bg-[#ecf0f3] animate-pulse">
      <div className="grid grid-cols-2 md:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="px-6 py-6 flex flex-col items-center justify-center">
            <div className="h-4 bg-gray-200 rounded w-20 mb-2"></div>
            <div className="h-6 bg-gray-200 rounded w-16"></div>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-2 border-t bg-white rounded-b-md py-2 px-3">
        <div className="h-4 bg-gray-200 rounded w-32"></div>
        <div className="h-4 bg-gray-200 rounded w-28"></div>
        <div className="h-4 bg-gray-200 rounded w-24"></div>
      </div>
    </div>
  );
};

export const TableSkeleton = ({ rows = 5 }: { rows?: number }) => {
  return (
    <div className="border rounded-lg overflow-hidden mt-4">
      <table className="w-full">
        <thead>
          <tr className="bg-[#ecf0f3]">
            <th className="px-4 py-3 text-left"><div className="h-4 bg-gray-200 rounded w-16"></div></th>
            <th className="px-4 py-3 text-left"><div className="h-4 bg-gray-200 rounded w-20"></div></th>
            <th className="px-4 py-3 text-left"><div className="h-4 bg-gray-200 rounded w-16"></div></th>
            <th className="px-4 py-3 text-left"><div className="h-4 bg-gray-200 rounded w-16"></div></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {Array.from({ length: rows }).map((_, i) => (
            <tr key={i} className="animate-pulse">
              <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-48"></div></td>
              <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-24"></div></td>
              <td className="px-4 py-3"><div className="h-6 bg-gray-200 rounded-full w-16"></div></td>
              <td className="px-4 py-3"><div className="h-6 bg-gray-200 rounded w-6"></div></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const CrawlerPageSkeleton = () => {
  return (
    <div className="animate-pulse p-6">
      <div className="h-8 bg-gray-200 rounded w-64 mb-6"></div>
      <div className="mb-6">
        <StatsCardSkeleton />
      </div>
      <div className="mb-4 flex justify-end">
        <div className="h-10 bg-gray-200 rounded w-48"></div>
      </div>
      <TableSkeleton />
    </div>
  );
};

export default StatsCardSkeleton;
